module.exports = "<main>\n  <router-outlet (activate)=\"onActivate()\">\n    <app-loader *ngIf=\"loading\"></app-loader>\n  </router-outlet>\n</main>\n"